import React from "react";
import { useNavigate } from "react-router-dom";

import PropertyManagersHeroBackground from "assets/Home/PropertyManagersHero.png";
import ManageRepairs from "./Home/ManageRepairs";
import SettingsIcon from "assets/Home/Settings.svg";
import SearchScanIcon from "assets/Home/SearchScan.svg";
import LinkIcon from "assets/Home/Link.svg";
import ServiceProfessionals from "./Home/ServiceProfessionals";
import LicenseInsurance from "assets/Home/LicenseInsurance.svg";
import Location from "assets/Home/Location.svg";
import Review from "assets/Home/Review.svg";
import Award from "assets/Home/Award.svg";
import HowItWorks from "./Home/PropertyWorlFlow";
import TransparentPricing from "./Home/TransparentPricing";
import FrequentlyAskedQuestions from "./Home/FrequentlyAskedQuestions";
import StayUpdated from "./Home/StayUpdated";
import LandlordPropertiesCTA from "./Home/LandlordPropertiesCTA";

const PropertyManagersLandingPage = () => {
  const navigate = useNavigate();

  const PropertyManagersHero = () => (
    <section className="w-full">
      <div
        className="relative min-h-[420px] w-full overflow-hidden bg-cover bg-center md:min-h-[500px] lg:min-h-[540px]"
        style={{ backgroundImage: `url(${PropertyManagersHeroBackground})` }}
      >
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(20,27,34,0.62)_0%,rgba(20,27,34,0.42)_42%,rgba(20,27,34,0.2)_100%)]" />
        <div className="relative mx-auto flex min-h-[420px] w-full max-w-[1440px] items-center px-5 py-16 md:min-h-[500px] md:px-12 lg:min-h-[540px]">
          <div className="max-w-[1120px] text-white">
            <h1 className="max-w-[1120px] text-[32px] font-medium leading-tight md:text-[56px] md:leading-[60px]">
              Your Job is to Manage Properties, Not Vendors
            </h1>
            <p className="mt-5 max-w-[820px] text-[16px] leading-[28px] text-white/90 md:text-[24px] md:leading-[38px]">
              Increase efficiency and stay in control by leveraging our vast
              network of vetted professionals, with no fee maintenance
              management.
            </p>
            <button
              type="button"
              onClick={() => navigate("/signup?account_type=PROPERTY_MANAGER")}
              className="mt-8 rounded-[10px] bg-[#47C272] px-6 py-3 text-[14px] font-medium text-white transition-all hover:bg-[#3cab5c] md:text-[16px]"
            >
              Get Started as a Property Manager
            </button>
          </div>
        </div>
      </div>
    </section>
  );

  const GetStartedCTA = (props) => (
    <div className="lg:max-w-[1440px] w-full mx-auto">
      <div className="w-full md:px-12 px-5 mt-2 mb-6">
        <button
          onClick={() => navigate("/signup?account_type=PROPERTY_MANAGER")}
          style={props.style}
          className="bg-[#47C272] hover:bg-opacity-90 text-white font-medium text-[16px] py-3 px-6 rounded-[8px] transition-all"
        >
          Get Started for Free
        </button>
      </div>
    </div>
  );

  const PropertyManagersPricingSection = () => (
    <div id="pricing-property-manager" className="lg:max-w-[1440px] w-full mx-auto">
      <div className="w-full md:px-12 md:py-[64px] px-5 py-8">
        <div className="w-full mx-auto flex flex-col gap-4 md:gap-8 lg:gap-[64px]">
          <div className="flex flex-col gap-3 md:gap-4 lg:gap-6">
            <h5 className="bg-[#3CAB5C1A] text-[#3CAB5C] px-3 py-1 rounded-full border border-[#3CAB5C] font-medium w-fit">
              Pricing
            </h5>
            <h2 className="font-medium w-full text-[#242424] text-[24px] md:text-[48px] leading-tight sm:leading-tight md:leading-tight lg:leading-[69px] tracking-[0] text-left">
              Here's How We Do It At No Cost To You
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-[14px] w-full">
            <div className="bg-[#F6F7F9] px-7 py-8 md:px-8 md:py-10 rounded-[20px]">
              <h3 className="text-[#242424] text-[18px] md:text-[22px] font-medium mb-4">
                No In-House Techs
              </h3>
              <p className="text-[#595959] text-[15px] md:text-[18px] leading-[30px]">
                We have minimal overhead. No big offices, no company trucks, no
                in-house technicians. Our business model is based on vendor
                partnerships. This approach allows us to deliver Properteasy for
                free while ensuring every job is completed efficiently and
                reliably.
              </p>
            </div>

            <div className="bg-[#F6F7F9] px-7 py-8 md:px-8 md:py-10 rounded-[20px]">
              <h3 className="text-[#242424] text-[18px] md:text-[22px] font-medium mb-4">
                Vendor Partnerships
              </h3>
              <p className="text-[#595959] text-[15px] md:text-[18px] leading-[30px]">
                Sometimes, size does matter. We send a steady stream of work to
                our vendors. In return, they share profits with us, but you
                never pay more than if you called the vendor yourself. With
                Properteasy, you get the same price, without the hassle of
                finding and coordinating reliable vendors on your own.
              </p>
            </div>
          </div>

          <div>
            <button
              type="button"
              onClick={() => navigate("/signup?account_type=PROPERTY_MANAGER")}
              className="bg-[#47C272] hover:bg-opacity-90 text-white font-medium text-[16px] py-3 px-6 rounded-[8px] transition-all"
            >
              Get Started for Free
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  const cards = [
    {
      icon: SettingsIcon,
      title: "We handle maintenance for you",
      description:
        "Tenants submit requests through our system, and we take care of assigning the right vendor. No calls, no back-and-forth, no stress.",
    },
    {
      icon: SearchScanIcon,
      title: "You can see what's going on",
      description:
        "Track the status of every job in your dashboard. Get updates, photos, and invoices without having to follow up with tenants or vendors.",
    },
    {
      icon: LinkIcon,
      title: "Everything in one place",
      description:
        "All requests, jobs, and payments are managed through one simple platform. No disorganized texts, emails, or paperwork.",
    },
  ];

  const cardsProfessionals = [
    {
      icon: LicenseInsurance,
      title: "Licensed & Insured",
    },
    {
      icon: Location,
      title: "Locally Vetted",
    },
    {
      icon: Review,
      title: "Highly Rated",
    },
    {
      icon: Award,
      title: "Satisfaction Guarantee",
    },
  ];

  const steps = [
    {
      number: "01",
      basis: "54%",
      title: "Tenant submits repair request",
      description:
        "Your tenant reports any issue through Properteasy by providing details, images, and scheduling availability. This gives us everything we need to get started. No landlord action is required.",
    },
    {
      number: "02",
      basis: "46%",
      title: "If you feel the work needs to be done, approve it!",
      description:
        "You're instantly notified of the request and can review the details and estimate at your leisure. If you choose to move forward, simply approve it with one click.",
    },
    {
      number: "03",
      basis: "48%",
      title:
        "We assess the issue and broadcast the job to the most suitable vendors",
      description:
        "Properteasy reviews the request, identifies the issue, and assigns it to the most qualified, local professionals.",
    },
    {
      number: "04",
      basis: "52%",
      title:
        "Vendor accepts the job at a time that works for your tenants",
      description:
        "A qualified vendor reviews the details and accepts the job based upon your tenants availability. They can alternatively provide access instructions so the work can get done, even if nobody's home.",
    },
    {
      number: "05",
      basis: "50%",
      title: "You're kept in the loop every step of the way",
      description:
        "You receive real-time updates throughout the process so you always know what's happening with your property, and when. No more wondering or chasing down job status from afar.",
    },
    {
      number: "06",
      basis: "50%",
      title: "Pay when the work is completed",
      description:
        "Once the maintenance request is resolved, you'll receive a final invoice. All payments are made securely and conveniently through Properteasy.",
    },
  ];

  return (
    <div
      style={{ marginTop: "96px" }}
      className="flex flex-col justify-center w-full items-center"
    >
      <PropertyManagersHero />
      <ManageRepairs
        id="property-maintenance-property-manager"
        chipTxt="Property Maintenance"
        iconStyle={{ opacity: 0.55 }}
        cards={cards}
        title="Everything You Need To Manage Repairs Without The Headaches"
        description="We handle repair requests from start to finish, including vendor dispatch and real-time progress updates. You stay in control without dealing with calls, scheduling, or follow ups."
      />
      <GetStartedCTA />
      <ServiceProfessionals
        id="end-to-end-repair-management-property-manager"
        cards={cardsProfessionals}
        iconStyle={{ opacity: 0.55 }}
        chipText="End-to-End Repair Management"
        title="Service Professionals You Can Trust"
        description="We get it, finding a trusted professional is hard. Properteasy removes the guesswork by vetting every service professional before they ever reach your door."
      >
        <div className="flex gap-[10px] text-[#242424] md:flex grid">
          <h2 className="text-[18px] md:text-[22px] bg-[#F6F7F9] w-full p-6 rounded-[20px]">
            Our rigorous evaluation process includes license and insurance
            verification, as well as client reference validation. Only those
            who demonstrate consistent excellence and reliability are given the
            opportunity to serve our landlords and their tenants.
          </h2>
          <h2 className="text-[18px] md:text-[22px] bg-[#F6F7F9] w-full p-6 rounded-[20px]">
            Our screening process is hands on, ensuring only the most
            dependable, skilled, and trustworthy vendors make the cut. Our
            service providers are established local tradesmen with proven track
            records, the professionals you wish you had from the start. With
            Properteasy, now you do.
          </h2>
        </div>
      </ServiceProfessionals>
      <PropertyManagersPricingSection />
      <HowItWorks
        id="how-properteasy-works-property-manager"
        chipText="Trusted by 20,000+ members"
        title="Here's How We Make Repairs Easy"
        steps={steps}
      />
      <TransparentPricing id="transparent-pricing-property-manager" />
      <GetStartedCTA />
      <LandlordPropertiesCTA
        id="contact-property-managers"
        title="Let's talk about your properties"
        description="Whether you manage one unit or hundreds, we'll help you streamline maintenance without adding overhead."
        buttonText="Contact Us to Learn More" buttonLink="/signup?account_type=PROPERTY_MANAGER"
      />
      <FrequentlyAskedQuestions id="faqs-property-manager" />
      <StayUpdated id="stay-updated-property-manager" />
    </div>
  );
};

export default PropertyManagersLandingPage;
